const JS_TOAST = 'js-toast';
const JS_TOAST_MESSAGE = 'js-toast-message';
const TOAST_CLASS = 'c-toast';

class Toast {
    constructor(element) {
        if(element){
            this.element = element;
    
            this.element.addEventListener('click', () => {
                this.show();
            });
        }
    }
    
    show(message = this.element.getAttribute(JS_TOAST_MESSAGE), duration = this.element.getAttribute(JS_TOAST)) {
        const toast = document.createElement('div');
        
        toast.classList.add(TOAST_CLASS);
        toast.innerHTML = message;
        toast.classList.add(`toast--${duration}`);
        document.body.appendChild(toast);

        toast.addEventListener("animationend", () => {
            toast.remove();
        });
    }

}

export default Toast;